import classNames from "classnames";
import Image from "next/image";
import { FC } from "react";
import { Container } from "~/components/Container";
import Icon from "~/components/Icon";
import { customerFeedbacks } from "~/constants/data";
import styles from "./CustomerFeedback.module.scss";
import InfiniteScroll from "~/components/InfiniteScroll";

interface Feedback {
  title: string;
  description: string;
  avatar: string;
  name: string;
  star: number;
  className?: string;
}
const FeedbackItem: FC<Feedback> = ({
  title,
  description,
  avatar,
  name,
  star,
  className,
}) => {
  return (
    <div className={classNames(styles.feedback_item, className)}>
      <div className="flex gap-3 items-center">
        <Image src={avatar} alt={name} width={48} height={48} />

        <div className="flex flex-col flex-1 gap-1">
          <p className={styles.name}>{name}</p>

          <div className="flex gap-1 items-center">
            <Icon name="verify-fill" size={20} color="#3BA55C" />
            <p className={styles.verified}>Verified purchaser</p>
          </div>
        </div>

        <div className="flex gap-1 items-center">
          <Icon name="star-fill" size={20} color="#FFB130" />
          <p className={styles.star}>{star}</p>
        </div>
      </div>

      <div className={styles.line} />

      <div className={styles.content}>
        <h4 className={styles.content_title}>{title}</h4>
        <p
          className={styles.content_description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};

const CustomerFeedback: FC = () => {
  return (
    <section className={styles.customer_feedback}>
      <Container className="flex flex-col gap-8 items-center">
        <h2 className={styles.title} data-aos="fade-down">
          See what people love about CX Genie
        </h2>
        <div className={styles.container} data-aos="fade-up">
          <div className="flex-[1.25] h-fit">
            <FeedbackItem {...customerFeedbacks[0]} />
          </div>
          <div className={styles.image}>
            <Image
              src="/images/customer_feedback.png"
              alt="Customer Feedback"
              fill
              className="hidden object-cover md:block"
            />
            <Image
              src="/images/customer_feedback_mobile.png"
              alt="Customer Feedback"
              fill
              className="block object-cover md:hidden"
            />
          </div>
          <div className={styles.feedbacks}>
            <InfiniteScroll
              direction="vertical"
              speed="slow"
              itemSpacing={8}
              items={customerFeedbacks.slice(1).map((feedback) => (
                <FeedbackItem key={feedback.name} {...feedback} />
              ))}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CustomerFeedback;
